module.exports = __webpack_public_path__ + "static/lemure-b964ecace17ce95c9242be8e620dc712.jpg";